<template>
  <main class="login">
    <section class="tam-2 cover"></section>
    <section class="alinha-v rel">
      <div class="margem">
        <p class="logo">Thalamus</p>
        <div v-if="isLoading" class="loading"><div></div></div>
        <p v-else-if="erro" class="erro-google">{{ erro }}</p>
      </div>
    </section>
  </main>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { createToaster } from "@meforma/vue-toaster";
import authService from "../services/authService";

const toaster = createToaster({
  position: "top-right",
  duration: 4000,
});

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isLoading = ref(true);
    const erro = ref("");

    onMounted(async () => {
      const errorCode = route.query.error;
      if (errorCode) {
        isLoading.value = false;
        erro.value = authService.mensagemErroGoogle(String(errorCode));
        toaster.show(erro.value, { type: "error" });
        setTimeout(() => router.replace({ name: "login" }), 2500);
        return;
      }

      const code = route.query.code;
      if (!code) {
        isLoading.value = false;
        erro.value = authService.mensagemErroGoogle("no_code");
        toaster.show(erro.value, { type: "error" });
        setTimeout(() => router.replace({ name: "login" }), 2500);
        return;
      }

      try {
        const payload = await authService.trocarCodigoGoogle(String(code));
        authService.registrarSessaoGoogle(payload);
        const { syncTenantKey } = await import("roboflex-thalamus-request-handler");
        const {
          enriquecerSessaoComMe,
          redirecionarAposLogin,
          registrarSessaoNoCofre,
        } = await import("@/services/sessionService");
        // Evita reload por “troca de tenant” no primeiro request pós-login.
        syncTenantKey();
        const usuario = await enriquecerSessaoComMe();
        const { vaultError } = registrarSessaoNoCofre(usuario);
        if (vaultError) {
          toaster.show(
            vaultError.message || "Limite de contas salvas atingido.",
            { type: "warning" }
          );
        }
        redirecionarAposLogin(usuario, router, route);
      } catch (e) {
        isLoading.value = false;
        const codeErr = e.response?.data?.code || "oauth_failed";
        erro.value = authService.mensagemErroGoogle(String(codeErr));
        toaster.show(erro.value, { type: "error" });
        setTimeout(() => router.replace({ name: "login" }), 2500);
      }
    });

    return { isLoading, erro };
  },
};
</script>

<style scoped>
.erro-google {
  color: var(--cor-erro, #c0392b);
  text-align: center;
  margin-top: 1rem;
}
</style>
